// extracted by mini-css-extract-plugin
export default {"root":"Header__root--r50HI"};